"use strict";

import Vue from 'vue';
import store from '../store';
import axios from "axios";
import {Message} from 'element-ui';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
let config = {
  baseURL: process.env.VUE_APP_URL,
  timeout: 20 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control,
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    config.headers.token = window.localStorage.getItem('token') || '';
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    if(response.data.code == 401){
      // 修改登陆状态
      store.commit('outLogin')
      Message.error('登陆已失效')
    }else if(response.data.code != 0){
      let msg = response.data.msg;
      if(msg){
        Message.error(response.data.msg)
      }
      return Promise.reject(msg);
    } 
    return response.data;
  },
  function(error) {
    Message.error(error)
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
